import React, { useEffect } from 'react';
import { Form, Input, Modal } from 'antd';

const { TextArea } = Input;

type Props = {
  open: boolean;
  incidentId: number | null;
  incidentLabel?: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: (incidentId: number, resolutionComment: string) => Promise<void>;
};

export const IncidentResolveModal: React.FC<Props> = ({
  open,
  incidentId,
  incidentLabel,
  loading = false,
  onCancel,
  onConfirm
}) => {
  const [form] = Form.useForm<{ resolutionComment: string }>();

  useEffect(() => {
    if (open) form.resetFields();
  }, [open, incidentId, form]);

  const handleOk = async () => {
    if (incidentId == null) return;
    const values = await form.validateFields();
    const comment = values.resolutionComment.trim();
    await onConfirm(incidentId, comment);
    form.resetFields();
  };

  return (
    <Modal
      open={open}
      title={incidentLabel ? `Закрыть: ${incidentLabel}` : 'Закрыть инцидент'}
      okText="Закрыть инцидент"
      cancelText="Отмена"
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={() => void handleOk()}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="resolutionComment"
          label="Причина устранения"
          rules={[
            { required: true, message: 'Укажите, как устранена проблема' },
            { min: 3, message: 'Минимум 3 символа' }
          ]}
        >
          <TextArea rows={3} placeholder="Что сделано, согласование, новый план" maxLength={2000} showCount />
        </Form.Item>
      </Form>
      <p className="execution-workspace__muted" style={{ fontSize: 11, margin: 0 }}>
        Сохраняются: кто закрыл, время закрытия, комментарий (audit trail).
      </p>
    </Modal>
  );
};

export default IncidentResolveModal;
